import { ClientRequestStatus } from 'src/types';

type ChipColor = 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger';

interface StatusMeta {
  label: string;
  color: ChipColor;
}

/** Etykiety i kolory statusów zgłoszeń (spójne z backendem). */
export const STATUS_META: Record<ClientRequestStatus, StatusMeta> = {
  new: { label: 'Nowe', color: 'primary' },
  open: { label: 'Otwarte', color: 'secondary' },
  in_progress: { label: 'W trakcie', color: 'warning' },
  resolved: { label: 'Rozwiązane', color: 'success' },
  closed: { label: 'Zamknięte', color: 'default' },
};

export const STATUS_OPTIONS: { key: ClientRequestStatus; label: string }[] = (
  Object.keys(STATUS_META) as ClientRequestStatus[]
).map((key) => ({ key, label: STATUS_META[key].label }));

export const getStatusMeta = (status?: ClientRequestStatus): StatusMeta => (status && STATUS_META[status]) || { label: status || '—', color: 'default' };

/** Skąd przyszła odpowiedź zapisana w zgłoszeniu. */
export const REPLY_CHANNEL_LABEL: Record<string, string> = {
  panel: 'Panel',
  slack: 'Slack',
  email: 'E-mail',
};

export const REPLY_CHANNEL_COLOR: Record<string, ChipColor> = {
  panel: 'primary',
  slack: 'secondary',
  email: 'warning',
};
